import { AxiosResponse } from 'axios'
import { useMutation } from 'react-query'
import { axiosInstance } from '../Services'

export interface GetBonhamImageRequest {
  imageName: string
}

const useGetBonhamImage = () => {
  const getBonhamImage = async (parameters: GetBonhamImageRequest): Promise<Blob> => {
    const { imageName } = parameters

    if (!imageName) {
      throw new Error('Image name is required')
    }

    // In development, use /admin/bonham-images endpoint (proxy will forward to http://localhost:5274/adminapi/bonham-images)
    // In production, use the full URL
    const endpoint =
      process.env.NODE_ENV === 'development'
        ? '/bonham-images'
        : `${process.env.REACT_APP_BASE_URL || ''}/bonham-images`

    const response = await axiosInstance.get<Blob>(endpoint, {
      params: { imageName },
      responseType: 'blob',
    })

    return response.data
  }

  return useMutation<Blob, AxiosResponse, GetBonhamImageRequest>(['get-bonham-image'], parameters =>
    getBonhamImage(parameters)
  )
}

export default useGetBonhamImage
